import {Model} from "@/store/models/model";


export class DomainNameserversDomains extends Model {

  static entity = 'domain_nameservers_domains'
  static primaryKey = ['domain_id', 'domain_nameserver_id']

  static fields() {
    return {
      domain_id: this.attr(null),
      domain_nameserver_id: this.attr(null)
    }
  }

}

export default DomainNameserversDomains



// WEBPACK FOOTER //
// ./src/store/pivot/domain_nameservers_domains.js